import { Particle } from "../engine/anims/Particle";
import { DMap } from "../lib/dMap/dMap";
import { RNGGenerator } from "../lib/rng";
import { SparseMap } from "../lib/sparseMap";
import { Action } from "./actions/Action";
import { Actor, ActorBreed } from "./actors/Actor";
import { Item } from "./items/Item";

import { ShrineMap } from "./map/ShrineMap";

export const buildState = (seed?: number) => {
  const seedRng = new RNGGenerator(seed || Date.now());
  const level = new ShrineMap(25, 25, seedRng.getGenerator());

  return {
    seedRng,
    current: level,
    actors: new SparseMap<Actor>(),
    items: new SparseMap<Item>(),
    gibs: new SparseMap<Particle<any>>(),
    particles: new SparseMap<Particle<any>>(),
    quickActionQueue: [] as Action<any>[],
    actionQueue: [] as Action<any>[],
    slowActionQueue: [] as Action<any>[],
    player: new Actor(-1, new ActorBreed("", {}), 0, 0),
    fov: new Map<number, boolean>(),

    //Player XP
    xp: 0,
    //AI & Navigaiton
    dMapPlayer: null as DMap | null,

    //UI Properties
    actionPending: false,
    looking: false,
    targetFocus: null as Particle<any> | null,

    seeAll: false,
  };
};

export type GameState = ReturnType<typeof buildState>;
